import HealthIndicatorEnum from '@/enums/HealthIndicatorEnum';

/**
 * Returns the theme color (success/error/warning) for a given health indicator
 * @param healthIndicator: The health indicator as HealthIndicatorEnum
 * @return Theme color as string
 */
export function healthColor(healthIndicator: HealthIndicatorEnum) {
  if (healthIndicator === HealthIndicatorEnum.HEALTHY) {
    return 'success';
  }
  if (healthIndicator === HealthIndicatorEnum.WARNING) {
    return 'warning';
  }
  if (healthIndicator === HealthIndicatorEnum.ERROR) {
    return 'error';
  }
  return '';
}

/**
 * Returns the health status as human-readable string
 * @param healthIndicator The health indicator
 * @return Health indicator as human readable string
 */
export function healthIndicatorText(healthIndicator: HealthIndicatorEnum) {
  if (healthIndicator === HealthIndicatorEnum.HEALTHY) {
    return 'Healthy';
  }
  if (healthIndicator === HealthIndicatorEnum.WARNING) {
    return 'Warning';
  }
  if (healthIndicator === HealthIndicatorEnum.ERROR) {
    return 'Error';
  }
  return 'Unknown';
}
